import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Modal from '../../components/Modal/Modal';

const EndUserAgreementModal = NiceModal.create(() => {
  const modal = useModal();
  return (
    <Modal
      title="End User Agreement"
      onClose={() => {
        modal.remove();
      }}
    >
      <p />
    </Modal>
  );
});

export default EndUserAgreementModal;
